import React, { useState } from 'react';
import { Modal, IconButton } from '@material-ui/core';
import CloseIcon from '@material-ui/icons/Close';
import KingBedIcon from '@material-ui/icons/KingBed';
import QueenBedIcon from '@material-ui/icons/SingleBedRounded';
import LaundryIcon from '@material-ui/icons/LocalLaundryService';
import PoolIcon from '@material-ui/icons/Pool';
import HotTubIcon from '@material-ui/icons/HotTub';
import BasketballIcon from '@material-ui/icons/SportsBasketball';
import TheatersIcon from '@material-ui/icons/Theaters';
import AcUnitIcon from '@material-ui/icons/AcUnit';
import WiFiIcon from '@material-ui/icons/Wifi';
import FenceIcon from '@material-ui/icons/ViewWeek';
import BbqIcon from '@material-ui/icons/OutdoorGrill';
import HockeyIcon from '@material-ui/icons/SportsHockey';
import TVIcon from '@material-ui/icons/Tv';
import AllTVIcon from '@material-ui/icons/AddToQueue';
import DVDIcon from '@material-ui/icons/PlayCircleFilled';
import ParkingIcon from '@material-ui/icons/DriveEta';
import VideoGameIcon from '@material-ui/icons/SportsEsports';
import ClubHouseIcon from '@material-ui/icons/Store';
import KitchenIcon from '@material-ui/icons/LocalDining';
import TennisIcon from '@material-ui/icons/SportsTennis';
import ResortIcon from '@material-ui/icons/Spa';
import './About.scss';

const About = () => {
  const [open, setOpen] = useState(false);

	const handleModalOpen = () => {
		setOpen(true)
	}

	const handleModalClose = () => {
		setOpen(false)
  } 
	const body = (
		<div className="about-modal">
      <IconButton className="about-modal-button" onClick={handleModalClose}>
        <CloseIcon />
      </IconButton>
      <table>
        <tr>
          <td><BasketballIcon />&emsp;&emsp;Game room</td>
          <td><PoolIcon />&emsp;Private pool</td>
          <td><AcUnitIcon />&emsp;Air Conditioner</td>
        </tr>
        <tr>
          <td><HockeyIcon />&emsp;air hockey</td>
          <td><HotTubIcon />&emsp;Hot Tub</td>
          <td><FenceIcon />&emsp;Privacy Fence</td>
        </tr>
        <tr>
          <td><TennisIcon />&emsp;Table Tennis</td>
          <td><TVIcon />&emsp;Big Screen TV</td>
          <td><DVDIcon />&emsp;DVD Player</td>
        </tr>
        <tr>
          <td><ParkingIcon />&emsp;3 Private parking spaces</td>
          <td><VideoGameIcon />&emsp;Video Games</td>
          <td><ClubHouseIcon />&emsp;Club House Access</td>
        </tr>
        <tr>
          <td><LaundryIcon />&emsp;Main and 2nd floor laundry</td>
          <td><ResortIcon />&emsp;Resort Amenities</td>
          <td><KitchenIcon />&emsp;Full Kitchen</td>
        </tr>
        <tr>
          <td><WiFiIcon />&emsp;Complimentary WiFi</td>
          <td><BbqIcon />&emsp;BBQ</td>
          <td><AllTVIcon />&emsp;TV in all bedrooms</td>
        </tr>
      </table>
		</div>
  )

  return (
    <div className="about">
      <h1>About</h1>
      <div className="about-tile">
        <h3>Sleeping Arangements</h3>
        <table>
          <tbody>
            <tr><th>Main Floor</th></tr>
            <tr><td><KingBedIcon />&emsp;&emsp;King master with en suite, pool and patio access</td></tr>
            <tr><td><KingBedIcon />&emsp;&emsp;King master with en suite</td></tr>
            <tr><td><QueenBedIcon />&emsp;&emsp;Queen bedroom with en suite/family bathroom (zero entry shower)</td></tr>
            <tr><th>2nd Floor</th></tr>
            <tr><td><KingBedIcon />&emsp;&emsp;King master with en suite</td></tr>
            <tr><td><KingBedIcon />&emsp;&emsp;King master with en suite</td></tr>
            <tr><td><KingBedIcon />&emsp;&emsp;King master with en suite</td></tr>
            <tr><td><QueenBedIcon /><QueenBedIcon />&emsp;Star Wars themed room (Twin/Full bunk beds)</td></tr>
            <tr><td><QueenBedIcon /><QueenBedIcon />&emsp;Frozen/Moana themed room (Twin/Full bunk beds)</td></tr>
          </tbody>
        </table>
      </div>
      <div className="about-tile">
        <h3>Amenities</h3>
        <table>
          <tbody>
            <tr><td><PoolIcon />&emsp;&emsp;Private pool and hot tub</td></tr>
            <tr><td><LaundryIcon />&emsp;&emsp;Main and 2nd floor laundry</td></tr>
            <tr><td><BasketballIcon />&emsp;&emsp;Game room</td></tr>
            <tr><td><TheatersIcon />&emsp;&emsp;Theater room</td></tr>
            <tr><td className="amenities-button" onClick={handleModalOpen}>SEE ALL AMENITIES</td></tr>
          </tbody>
        </table>
      </div>
      <div className="about-tile">
        <h3>Details</h3>
        <p>This 8 bedroom luxury villa, located at the Encore Resort at Reunion, is about a 10 minute drive to Walt Disney World!
          You will have the perfect location for a full family Disney vacation or many of the other exciting attractions the
          Orlando area has to offer. Additionaly, access to the Encore Resort at Reunion can add to your stay with exclusive
          amenities like multiple bars and restaurants, a thrilling waterpark, and 24 hour customer service on site.
          Sleeping up to 17 people, this vacation home has bedrooms across both floors including 2 children's themed 
          bedrooms! You also have your very own private swimming pool and spillover hot tub right outside your patio doors
          where you can enjoy the Florida sunshine any time of day. The entertainment does not end at the theme parks. If
          you are in need of some relaxation, enjoy time inside with a game room and home theater room with large projection
          screen.</p>
        <p>The living room on the main floor has a spacious comfortable seating area with two leather sofas, an accent
          chair overlooking the private pool deck through sliding glass doors, large flat screen TV, and a feature
          fireplace. The kitchen is fully equipped with a black granite 5 seat island style breakfast bar, two 
          refrigerator/freezers, oven, microwave, 2 dishwashers, coffee maker, toaster, blender, all utensils, cookware,
          dinnerware, glassware. Dining room table seats up to 14 people</p>
        <p>Each bedroom is furnished with a flat screen TV and access to complimentary Wifi. Main living area has a large flat screen TV and a feature fireplace.
          Home theater has a large projection screen, 5x leather recliners, 2x mini leather recliners and 3x bean bag chairs for children.
          Game room has an air hockey and ping pong table, basketball shooting game, and cornhole. Upper floor loft area has a flat screen TV and video arcade game</p>
        <p>Private swimming pool and spillover spa (optional heating). 4x sun loungers, 6 seat patio table, 2x outdoor sofas as well as a round sofa.
          Firepit (gas available locally) with 4x patio chairs, 6 seat high top table. Outdoor umbrella, fridge, TV, and fans 
          BBQ (gas available locally). Child safety fence</p>
      </div>
      <Modal open={open} onClose={handleModalClose}>
        {body}
      </Modal> 
    </div>
  );
}

export default About;